import { Box } from "@chakra-ui/react";
import { forwardRef } from "react";

import { Icon } from "@components/atoms";

import { StyledRating } from "./styles";

type RatingProps = {
  size: number;
  rate: number;
  fillColor: string;
  showText?: boolean;
};

export const Rating = forwardRef<HTMLDivElement, RatingProps>(
  ({ size, rate, fillColor, showText }, ref) => {
    const buttons: any = [0, 0, 0, 0, 0];

    if (rate && rate > 0) {
      // consider rating 0 to 4 as per array index
      const rating = Math.floor(rate) - 1;
      const fractionalPart = Number((rate - (rating + 1)).toFixed(1));

      // Push the integer part of the rating (full stars)
      for (let i = 0; i <= rating; i++) {
        buttons[i] = 1;
      }
      // Push the partially filled star if there's a fractional part
      if (fractionalPart > 0) {
        buttons[rating + 1] = fractionalPart;
      }
    }

    const hideRating = rate <= 0;
    const ratingCeiling = Math.ceil(rate * 10) / 10;

    return (
      <Box display="flex" alignItems="center" flexDirection="column" ref={ref}>
        <Box display="flex" flexDirection="row">
          {!hideRating &&
            buttons.map((item: number, index: number) => (
              <StyledRating key={index}>
                <Icon
                  name="star_full"
                  size={size}
                  color={fillColor}
                  fillOpacity={item}
                  translateX={7}
                  fractionalPart={item ? item % 1 : 0}
                />
              </StyledRating>
            ))}
        </Box>
        {showText ? (
          hideRating ? (
            <Box>
              <p>No Customer Reviews received yet</p>
            </Box>
          ) : (
            <Box>
              <p>{ratingCeiling} Stars</p>
            </Box>
          )
        ) : null}
      </Box>
    );
  }
);
